import { Component, Prop } from '@stencil/core';
import { Price, TotalPriceCalculation } from '../../../types/types';
import { Unsubscribe } from '@stencil/redux';
import { store } from '../../../redux/store';
import { formatPrice, t } from '../../../redux/utils';
import { RootState } from '../../../redux/reducers';

@Component({
  tag: 'rentware-total-price',
  shadow: false,
})
export class RentwareTotalPrice {
  @Prop() price!: Price;
  @Prop() priceCalculation?: TotalPriceCalculation; // needed in no cart cases
  @Prop() showTotalText = true;
  @Prop({ mutable: true }) totalPriceCalculation: TotalPriceCalculation;
  @Prop({ mutable: true }) displayNet: boolean;

  unsubscribe!: Unsubscribe;

  componentWillLoad() {
    this.unsubscribe = store.mapStateToProps(this, (state: RootState) => {
      return {
        displayNet: state.system.pricing.priceDisplay === 'net',
        totalPriceCalculation: state.cart?.totalPriceCalculation,
      };
    });
  }

  disconnectedCallback() {
    this.unsubscribe();
  }

  get totalPrice(): string {
    if (!this.price) {
      return null;
    }

    const price = this.displayNet ? this.price.net : this.price.gross;
    const transParams = { total: formatPrice(price) };

    if (!this.showTotalText) {
      return transParams.total;
    }

    if (this.priceCalculation === TotalPriceCalculation.Interval || this.totalPriceCalculation === TotalPriceCalculation.Interval) {
      return t('cart.total', transParams);
    }
    if (this.priceCalculation === TotalPriceCalculation.Month || this.totalPriceCalculation === TotalPriceCalculation.Month) {
      return t('cart.totalPerMonth', transParams);
    }

    return null;
  }

  render() {
    return this.totalPrice;
  }
}
